
import {TEMPLATES, THEMES,PLATFORMS } from "../../const";

export  const prepareCardData = (data) => {
  if (!data) {
    return null;
  }

  const selectedTheme =
      THEMES.find(
        (theme) => theme.id === data.theme
      ) ||
      THEMES.find(
        (theme) => theme.id === "ink"
      );
    // =========================================================
    // GET SELECTED PLATFORMS
    // =========================================================
    const selectedPlatforms = PLATFORMS.filter(
      (platform) =>
        data.platforms?.includes(platform.id)
    );
  
    // =========================================================
    // FILTERED LINKS
    // Only platforms with a link
    // =========================================================
    const filteredLinks = selectedPlatforms.filter(
      (platform) =>
        data.platformLinks?.[platform.id]
    );
  
    // =========================================================
    // SOCIAL LINKS
    // =========================================================
    const socialLinks = filteredLinks.filter(
      (platform) =>
        platform.type === "social"
    );
  
    // =========================================================
    // GET CARD TYPE
    // =========================================================
    
  
   

  return {
    ...data,
    selectedTheme,

    selectedPlatforms,

    filteredLinks,

    socialLinks,
  };
};